<div class="p1">
    @if (firstLine) {
    <p class="fw-bold"
       data-cs-mask>{{firstLine}},</p>
    }
    @if (secondLine) {
    <p data-cs-mask>{{secondLine}}</p>
    }
    @if (secondLine) {
    <p data-cs-mask>{{thirdLine}}</p>
    }
    @if (model?.data?.telephone) {
    <p data-cs-mask>{{model.data.telephone}}</p>
    }
</div>